import { HeroSection, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import React from 'react';
import { useSelector } from 'react-redux';
import { SKELETON_CLASSNAME } from '../../base/constants';
import SideBarSection from '../../components/SideBarSection/SideBarSection';
import { GroupAdminBanner } from '../../groupAdmin';
import EvaluationSideBar from '../EvaluationSideBar';
import TabSwitch from '../TabSwitch';
import * as Selectors from '../selectors';
import { EStatisticsTabs } from '../types';
import useUserIdFromRoute from '../useUserIdFromRoute';
import ComparisonView from './ComparisonView';
import PerformanceView from './PerformanceView';

export const ExerciseStatistics: React.FC = () => {
  const { language, t } = useTranslation();
  const userId = useUserIdFromRoute();
  const [selectedTab, setSelectedTab] = React.useState<EStatisticsTabs>(EStatisticsTabs.Comparison);

  const ready = useSelector(Selectors.isFeatureReady);

  const evaluationLottie = 'Lab_Animation360';
  const loaded = ready && !!language;
  const skeletonClass = loaded ? '' : SKELETON_CLASSNAME;

  const subTitle = userId ? t('Evaluation.Statistics.SubTitleUser') : t('Evaluation.Statistics.SubTitle');
  const sidebar = <EvaluationSideBar />;
  return (
    <>
      <HeroSection lottie={evaluationLottie} className="evaluation-section">
        <SectionTitle className={skeletonClass}>{t('Evaluation.Statistics.PageTitle')}</SectionTitle>
        <SectionSubtitle className={skeletonClass}>{subTitle}</SectionSubtitle>
      </HeroSection>
      <GroupAdminBanner userId={userId} />
      <SideBarSection sidebar={sidebar}>
        <div className="col-2"></div>
        <div className="col-7">
          <TabSwitch
            tabs={[EStatisticsTabs.Comparison, EStatisticsTabs.Performance]}
            titlePrefix="Evaluation.Statistics.Tab.Title"
            active={selectedTab}
            onClick={setSelectedTab}
          />
          {selectedTab === EStatisticsTabs.Comparison && <ComparisonView userId={userId} />}
          {selectedTab === EStatisticsTabs.Performance && <PerformanceView />}
        </div>
      </SideBarSection>
    </>
  );
};

export default ExerciseStatistics;
